export default __webpack_public_path__ + "static/media/xtokens logo.daa9b938.svg";